import { useLocation, useNavigate } from 'react-router-dom';

import {
  openErrorNotification,
  openSuccessNotification,
  isErrorWithMessage,
} from 'shared/lib';

import { useCustomAddGroupMutation, GroupType } from 'entities/group';
import {
  ConnectedPersonsGroupForm,
  PersonsGroupFormData,
} from 'entities/persons-group';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';

// TEMP
import { PERSON_ROUTES } from 'shared/consts/routes/person';
//

const initialValues: PersonsGroupFormData = {
  parentId: '',
  name: '',
  comment: '',
  discountId: '',
};

export function AddPersonsGroup() {
  const [trigger, { isLoading }] = useCustomAddGroupMutation();

  const navigate = useNavigate();

  const location = useLocation();

  const handleSubmit = async (values: PersonsGroupFormData) => {
    const { name, comment, parentId } = values;

    const req = {
      name,
      comment,
      groupType: 1 as GroupType,
      parentId,
    };

    try {
      const res = await trigger(req).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      // const path = location.pathname.replace(`/${CREATE_ENTITY_PREFIX}`, '');

      navigate(PERSON_ROUTES.PERSONS_GROUPS_LIST);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <ConnectedPersonsGroupForm
      title="Добавление новой группы"
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
